import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Dialog, Stack, Typography } from '@mui/material';
import { toast } from '../../../../../utils';
import {
  MEDICINE_DOSE,
  MEDICINE_FREQUENCY,
  MEDICINE_NAME,
  MEDICINE_UNIT,
  OCCUPY_STATUS,
  YES_NO
} from '../../../../../constants';
import { yupResolver } from '@hookform/resolvers/yup';
import AddIcon from '@mui/icons-material/Add';
import * as Yup from 'yup';
import { useCallback, useEffect, useState, useRef } from 'react';
import { IcdDiagnosisDetailsForm } from './IcdDiagnosisDetailsForm';
import { FrequencyMasterDetailsForm } from './utils/FrequencyMasterDetailsForm';
import { DoseMasterDetailsForm } from './utils/DoseMasterDetailsForm';
import { ProductmasterDetailsForm } from './utils/ProductMasterDetailsForm';

export const DischargeSummaryMedicineDetailsForm = ({
  onAdd,
  onClose,
  medicine = [],
  dose = [],
  frequency = [],
  setFrequency,
  setDose,
  setMedicine,
  getMedicineDropdown
}) => {
  const [frequencyDialogue, setFrequencyDialogue] = useState(false);
  const [productDialogue, setProductDialogue] = useState(false);
  const [doseDialogue, setDoseDialogue] = useState(false);
  const [diagnos, setDiagnos] = useState([]);
  const medicineRef = useRef();
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        medicine_name: Yup.string().required(' '),
        // unit: Yup.string().required(' '),
        frequency: Yup.string().required(''),
        dose: Yup.string().required(''),
        morning: Yup.string().required(''),
        noon: Yup.string().required(''),
        evening: Yup.string().required(''),
        night: Yup.string().required(''),
        days: Yup.string().required('')
      })
    ),
    defaultValues: {
      medicine_name: 'Dolo',
      morning: true,
      noon: true,
      evening: true,
      night: true
    },
    mode: 'all'
  });
  const { handleSubmit, reset, watch, setValue } = methods;

  const formSubmit = (formValue) => {
    const medicineDetail = medicine.find((detail) => detail.main?.name === formValue.medicine_name);
    const medicineId = medicineDetail?.product._id || '';
    const rate = medicineDetail?.rate || '';
    const expDate = medicineDetail?.exp_date || '';
    const batchNo = medicineDetail?.batch_no || '';
    const hsnCode = medicineDetail?.hsn_code || '';
    const gst = medicineDetail?.gst || '';
    const transformedValues = {
      ...formValue,
      medicine: medicineId,
      rate: rate,
      exp_date: expDate,
      batch_no: batchNo,
      hsn_code: hsnCode,
      gst: gst
    };
    console.log('HELLO TRANSFORMED VALUES', transformedValues);
    onAdd(transformedValues);
    reset();
    if (medicineRef.current) {
      medicineRef.current.focus();
    }
  };

  useEffect(() => {
    if (medicineRef.current) {
      medicineRef.current.focus();
    }
  }, []);

  const selectedMedicineName = watch('medicine_name');

  useEffect(() => {
    if (selectedMedicineName) {
      const selectedMedicine = medicine.find((item) => item._id === selectedMedicineName);
      console.log('Selected Medicine:', selectedMedicine);

      if (selectedMedicine) {
        setValue('unit', selectedMedicine?.main?.purchasing_unit?.unit_name || '');
      }
    }
  }, [selectedMedicineName, setValue, medicine]);

  const handleAddDose = (newFrequency) => {
    setDose((prev) => [...prev, newFrequency]);
  };
  const handleAddFrequency = (newFrequency) => {
    setFrequency((prev) => [...prev, newFrequency]);
  };
  const handleAddProduct = (newFrequency) => {
    setMedicine((prev) => [...prev, newFrequency]);
  };
  return (
    <>
      <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Medicine Name</Typography>
          <SelectTag
            formControlSX={{ flex: 0.6 }}
            name="medicine_name"
            placeholder="Medicine Name"
            menus={medicine.map((data) => ({ ...data, name: data.main?.name }))}
            inputRef={medicineRef}
          />
          <Button sx={{ flex: 0.1, minWidth: 0, p: 0.25 }} variant="contained" onClick={() => setProductDialogue(true)}>
            <AddIcon />
          </Button>
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Unit</Typography>
          <TextField sx={{ flex: 0.6 }} name="unit" placeholder="Unit" disabled />
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Frequency</Typography>
          <SelectTag
            formControlSX={{ flex: 0.6 }}
            name="frequency"
            placeholder="Frequency"
            menus={frequency.map((data) => ({ ...data, name: data.frequency, _id: data?._id }))}
          />
          <Button
            sx={{ flex: 0.1, minWidth: 0, p: 0.25 }}
            variant="contained"
            onClick={() => setFrequencyDialogue(true)}
          >
            <AddIcon />
          </Button>
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Dose</Typography>
          <SelectTag
            formControlSX={{ flex: 0.6 }}
            placeholder="Dose"
            name="dose"
            menus={dose.map((data) => ({ ...data, name: data.dose, _id: data?._id }))}
          />
          <Button sx={{ flex: 0.1, minWidth: 0, p: 0.25 }} variant="contained" onClick={() => setDoseDialogue(true)}>
            <AddIcon />
          </Button>
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Morning</Typography>
          <Checkbox formControlSX={{ flex: 0.6 }} name="morning" fontSize={18} />
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Noon</Typography>
          <Checkbox formControlSX={{ flex: 0.6 }} name="noon" fontSize={18} />
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Evening</Typography>
          <Checkbox formControlSX={{ flex: 0.6 }} name="evening" fontSize={18} />
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Night </Typography>
          <Checkbox formControlSX={{ flex: 0.6 }} name="night" fontSize={18} />
        </Stack>
        <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={{ flex: 0.4, flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Days</Typography>
          <TextField sx={{ flex: 0.6 }} name="days" placeholder="Days"  type="number"/>
        </Stack>
        <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
          <Button variant="contained" type="submit">
            Add
          </Button>
          <Button color="error" onClick={onClose}>
            Close
          </Button>
        </Stack>
      </FormProvider>
      <Dialog
        PaperProps={{ sx: { p: 2, width: '40rem', height: '15rem' } }}
        open={frequencyDialogue}
        onClose={() => setFrequencyDialogue(false)}
        scroll="body"
        maxWidth="xl"
      >
        <FrequencyMasterDetailsForm
          onClose={() => setFrequencyDialogue(false)}
          setFrequencyDialogue={setFrequencyDialogue}
          onAddFrequency={handleAddFrequency}
          setFrequency={setFrequency}
        />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { p: 2, width: '40rem', height: '15rem' } }}
        open={doseDialogue}
        onClose={() => setDoseDialogue(false)}
        scroll="body"
        maxWidth="xl"
      >
        <DoseMasterDetailsForm
          onClose={() => setDoseDialogue(false)}
          setDoseDialogue={setDoseDialogue}
          onAddDose={handleAddDose}
          setDose={setDose}
        />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { p: 2, width: '40rem', height: '15rem' } }}
        open={productDialogue}
        onClose={() => setProductDialogue(false)}
        scroll="body"
        maxWidth="xl"
      >
        <ProductmasterDetailsForm
          onClose={() => setProductDialogue(false)}
          setProductDialogue={setProductDialogue}
          onAddProduct={handleAddProduct}
          setMedicine={setMedicine}
          getMedicineDropdown={getMedicineDropdown}
        />
      </Dialog>
    </>
  );
};
